// pages/limousine/index.jsx
/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Header3 from "../../components/header/header-rslhome";
import Seo from "../../components/common/Seo";
import CtaButton from "../../components/buttonWithArrow";
import PickYourCarGrid from "../../components/Investments/PickYourCarToInvest";
import RoiInvestorBenefits from "../../components/Investments/RoiInvestorBenefits";
import { ECOMMERCE_PAGE } from "../../data/ecommerce";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import Footer3 from "../../components/footer/footer-new";
import { Box } from "@mui/material";
import InvestmentSimulatorFlow from "../../components/Investments/EcommerceCalculatore";
import { useEffect, useState } from "react";
import InvestNow from "../../components/investNow";
import { useDispatch, useSelector } from '../../redux/store'
import { getEcommerceList, ecommerceInvestNow } from "../../redux/slices/investments";
import AfterFormSubmit from "../../components/investNow/AfterFormSubmit";
import { bannerHeight } from "../../utils/bannerHeight";
import { fetchSeoByPage } from "../../lib/seoHelper";

export default function Ecommerce({ meta }) {
  const dispatch = useDispatch();
  const [costCalculateOpen, setCostCalculateOpen] = useState(false);
  const [openInvestForm, setOpenInvestForm] = useState(false);
  const [loader, setLoader] = useState(false);
  const [investFormLoader, setInvestFormLoader] = useState(false);
  const [listData, setListData] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");
  const [status, setStatus] = useState(null);
  const [openValid, setOpenValid] = useState(false);
  const [priceData, setPriceData] = useState([]);
  const [bannerImage, setBannerImage] = useState(null);
  const { ecommerceListRes, ecommerceEnquiryRes } = useSelector(
    state => state.investment
  );
  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "971",
    editedTotalPrice: "",
    editedROI: ""
  })

  const handleCloseInvestForm = () => setOpenInvestForm(false);
  const handleOpenInvestForm = () => setOpenInvestForm(true);

  useEffect(() => {
    dispatch(getEcommerceList());
  }, [dispatch])

  useEffect(() => {
    if (ecommerceListRes) {
      if (ecommerceListRes?.status === 1) {
        setListData(ecommerceListRes?.responseData);
        setPriceData(ecommerceListRes?.priceData?.priceList)
        setBannerImage(ecommerceListRes?.ecommerceBannerImage);
      } else {
        setListData([]);
        setPriceData([]);
        setBannerImage(null);
      }
    }
  }, [ecommerceListRes])

  const handleSubmit = (value) => {
    const obj = {
      ...value,
      formType: 2,
      currency: typeof window !== "undefined"
        ? JSON.parse(sessionStorage.getItem("currency") || "{}")?.value || "aed"
        : "aed"
    }
    setLoader(true);
    dispatch(ecommerceInvestNow(obj));
  }

  useEffect(() => {
    if (ecommerceEnquiryRes && loader) {
      setLoader(false);
      setInvestFormLoader(false);
      if (ecommerceEnquiryRes?.status === 1) {
        setOpenValid(true);
        setStatus(ecommerceEnquiryRes?.status)
        setStatusMessage(ecommerceEnquiryRes?.message)
      } else {
        setStatus(-1);
        setStatusMessage(ecommerceEnquiryRes?.message || "An error occurred, please try again.");
        setOpenValid(true);
      }
    }
  }, [ecommerceEnquiryRes])

  const handleInvestFormSubmit = (value) => {
    const obj = {
      ...value,
      formType: 1,
      currency: typeof window !== "undefined"
        ? JSON.parse(sessionStorage.getItem("currency") || "{}")?.value || "aed"
        : "aed"
    }

    setInvestFormLoader(true);
    dispatch(ecommerceInvestNow(obj));
  }

  const handleCloseCalculator = () => {
    setCostCalculateOpen(false);
    setValues({
      name: "",
      email: "",
      phone: "",
      countryCode: "971",
      editedTotalPrice: "",
      editedROI: ""
    })
  }

  const reset = () => {
    setLoader(false);
    setInvestFormLoader(false);
    handleCloseCalculator();
    handleCloseInvestForm();

  }

  const handleCloseValid = () => {
    if (status === 1) {
      reset();
    }
    setOpenValid(false);
    setStatusMessage("");
    setStatus(null);
  }

  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />

      <section
        className="hero"
        style={{
          position: "relative",
          width: "100%",
          height: bannerHeight(),
          overflow: "hidden",
        }}
      >
        {/* Fixed background layer */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: bannerHeight(),
            zIndex: 0,
          }}
        >
          {/* BG image */}
          <Image
            src={`${process.env.IMAGE_BASE_URL}/${bannerImage}`}
            alt="limousine"
            fill
            priority
            sizes="100vw"
            style={{ objectFit: "cover" }}
          />
          {/* Gradient overlay */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              top: 0,
              background: "linear-gradient(to top, rgb(0 0 0 / 79%) 0%, rgba(0, 0, 0, 0) 50%)",
              zIndex: 1,
              pointerEvents: "none",
            }}
          />
          {/* dark gradient overlay */}
          {/* <div className="overlay" aria-hidden="true" /> */}

          {/* content */}
          <div className="content">
            <h1 className="title jura">
              <span className="scribble-wrap">
                <span className="scribble-text">Invest</span>
                {/* teal hand-drawn oval */}
                <img
                  src="/img/header/Oval.svg"
                  alt=""
                  className="scribble"
                />
              </span>{" "}
              in Ecommerce
            </h1>

            <div className="cta">
              <CtaButton label="Cost Calculator" onClick={() => setCostCalculateOpen(true)} />
              {/* <CtaButton cta={{ label: "Check Fleet", href: "#fleet" }} endIconSrc="/img/header/VectorDown.svg" /> */}
            </div>
          </div>
        </div>
      </section>

      {/* 👇 important: push content BELOW fixed hero */}
      <Box
        id="fleet"
        sx={{
          position: "relative",
          zIndex: 3,
          pt: `${bannerHeight()}px`,
        }}
      >
        <Box id="investmentGuide" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <RoiInvestorBenefits data={ECOMMERCE_PAGE?.productList} onClick={(val) => handleOpenInvestForm()} />
        </Box>
        <Box id="investmentGuide" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <RoiInvestorBenefits data={ECOMMERCE_PAGE?.approvesBusiness} onClick={(val) => handleOpenInvestForm()} />
        </Box>
        <Box sx={{ background: "#fff" }}>
          <CommunicationChannel data={ECOMMERCE_PAGE.communicationChannel} />
        </Box>
        <Footer3 bgcolor="#f8f8f8" />
      </Box>
      <style jsx>{`
        :global(html, body) {
         scroll-behavior: smooth;
          overflow-x: hidden;
        }

        .hero {
          position: relative;
          width: 100%;
          // min-height: clamp(60vh, 72vh, 80vh);
          min-height: ${bannerHeight()};
          border-radius: 0;
          isolation: isolate; /* ensure overlay/contents stack correctly */
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.78) 0%,
              rgba(0, 0, 0, 0.55) 35%,
              rgba(0, 0, 0, 0.08) 70%,
              rgba(0, 0, 0, 0) 100%
            ),
            radial-gradient(60% 60% at 50% 50%, rgba(0, 0, 0, 0.25), transparent 70%);
          z-index: 1;
          pointer-events: none;
        }

        .content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: grid;
          place-items: end center;
          padding: clamp(16px, 4vw, 28px);
          /* push content slightly above bottom like the mock */
          align-content: end;
          gap: clamp(16px, 3vh, 28px);
          padding-bottom: clamp(36px, 10vh, 40px);
          text-align: center;
        }

        .title {
          color: #ffffff;
          font-weight: 600;
          letter-spacing: 0.02em;
          line-height: 1.1;
          margin: 0;
          /* responsive font like the design */
          font-size: clamp(28px, 6.5vw, 52px);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        }

        .scribble-wrap {
          position: relative;
          display: inline-block;
        }

        .scribble-text {
          position: relative;
          z-index: 2;
        }

        .scribble {
          position: absolute;
          z-index: 1;
          left: -0.35em;
          top: 5px;
          width: clamp(7.5em, 14vw, 13em); /* scales with font size */
          height: auto;
          transform: rotate(-4deg);
          pointer-events: none;
          filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
          opacity: 0.95;
        }

        .cta {
          display: flex;
          justify-content: center;
        }

        /* Button polish to match mock (rounded pill + subtle shadow) */
        :global(.cta button),
        :global(.cta a) {
          border-radius: 999px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .content {
            padding-bottom: 48px;
          }
          .scribble {
            left: -0.3em;
            top: 10px;
          }
        }

        @media (max-width: 420px) {
          .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
          }
          .scribble {
            width: 8.8em;
          }
        }
      `}</style>

      <InvestmentSimulatorFlow
        open={costCalculateOpen}
        onClose={() => handleCloseCalculator()}
        onInvest={(p) => handleSubmit(p)}
        setValues={setValues}
        values={values}
        formLoader={loader}
        listData={listData}
        priceData={priceData}
      />

      <AfterFormSubmit open={openValid} status={status} message={statusMessage} onClose={handleCloseValid} />

      <InvestNow
        open={openInvestForm}
        onClose={handleCloseInvestForm}
        fleetCard={listData}
        handleSubmit={handleInvestFormSubmit}
        loader={investFormLoader}
        setLoader={setInvestFormLoader}
        labels={["Name", "Email", "Phone", "Select Product", "Document"]}
        apiResponse={ecommerceEnquiryRes}
      />

    </>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}